import { acceptHMRUpdate, defineStore } from 'pinia';

export const useExpeditionsStore = defineStore('expeditions', {
  state: () => ({
    /** Pedido desde 0. */
    dateFilterExpedition: null,

    /** Datos del cliente actual. */
    filtersExpedition: {
      Cliente: null,
      Pedido: null,
      Articulo: null,
      Matricula: null,
      Orden: null,
      Almacen: null,
      Transportista: null,
      Nacionalidad: '',
    },
    itemAcordeonOpen: null,
  }),

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useExpeditionsStore, import.meta.webpackHot));
}
